var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMathsLogoSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 0H1.44444C0.65 0 0 0.65 0 1.44444V11.5556C0 12.35 0.65 13 1.44444 13H11.5556C12.35 13 13 12.35 13 11.5556V1.44444C13 0.65 12.35 0 11.5556 0ZM7.24389 2.93222L8.00945 2.16667L9.02778 3.185L10.0461 2.16667L10.8117 2.93222L9.79333 3.95056L10.8117 4.96889L10.0461 5.73444L9.02778 4.72333L8.00945 5.74167L7.24389 4.97611L8.26222 3.95778L7.24389 2.93222ZM2.34722 3.40889H5.95833V4.49222H2.34722V3.40889ZM6.13889 9.38889H4.69444V10.8333H3.61111V9.38889H2.16667V8.30556H3.61111V6.86111H4.69444V8.30556H6.13889V9.38889ZM10.8333 10.2917H7.22222V9.20833H10.8333V10.2917ZM10.8333 8.48611H7.22222V7.40278H10.8333V8.48611Z",
    fill: "#FFA177"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsLogoSelected);
export default __webpack_public_path__ + "static/media/MathsLogoSelected.f582463da1d6d40ec24e681b9c6eee00.svg";
export { ForwardRef as ReactComponent };